import { Component, ReactNode } from 'react';
import { errorReporter, FeatureTag } from '@/services/errorReportingService';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  feature?: FeatureTag;
  operation?: string;
}

interface State {
  hasError: boolean;
}

class SilentErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    errorReporter.expected(
      `ErrorBoundary caught error in ${this.props.feature ?? 'unknown'}/${this.props.operation ?? 'unknown'}`,
      error,
      {
        feature: this.props.feature,
        operation: this.props.operation ?? 'errorBoundary',
      },
    );
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}

export default SilentErrorBoundary;
